import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CTA() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const next = email.trim();
    navigate(next ? `/register?email=${encodeURIComponent(next)}` : '/register');
  };

  return (
    <section id="cta" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_40%,#E25A3C_0%,transparent_45%),linear-gradient(180deg,#f6efe6_0%,#7a4030_55%,#2b1a15_100%)]" />
      <div className="absolute inset-0 bg-gradient-to-b from-background-100 via-primary-900/70 to-primary-950/80" />

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-24">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-background-50">
            准备好看清你的网站流量了吗？
          </h2>
          <p className="mt-4 text-background-100/90 leading-relaxed">
            留下邮箱，免费开通账号。30 秒即可拥有专业级的流量统计看板。
          </p>

          <form
            onSubmit={handleSubmit}
            className="mt-8 flex flex-col sm:flex-row items-stretch gap-3 max-w-lg mx-auto"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              className="flex-1 px-5 py-3.5 rounded-md bg-background-50 text-foreground-900 text-sm placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-accent-400"
            />
            <button
              type="submit"
              className="px-7 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors whitespace-nowrap"
            >
              免费开通
            </button>
          </form>

          <p className="mt-4 text-xs text-background-100/70">
            注册即代表同意{' '}
            <a href="/terms" className="underline">
              服务条款
            </a>{' '}
            与{' '}
            <a href="/privacy" className="underline">
              隐私政策
            </a>
            ，无需绑定支付方式。
          </p>
        </div>
      </div>
    </section>
  );
}
